var _rect, _path, _rect2, _path2, _rect3, _path3, _rect4, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwotColoured(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 11.52,
    height: 11.52,
    rx: 5.76,
    fill: "#52D783"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.26958 8.935C5.98625 8.935 5.72125 8.9 5.47458 8.83C5.22791 8.76 5.01791 8.66333 4.84458 8.54L5.07458 7.93C5.18791 8.00667 5.30791 8.07167 5.43458 8.125C5.56125 8.17833 5.69458 8.22 5.83458 8.25C5.97458 8.27667 6.12125 8.29 6.27458 8.29C6.51458 8.29 6.68458 8.25333 6.78458 8.18C6.88791 8.10667 6.93958 8.01333 6.93958 7.9C6.93958 7.79667 6.90458 7.71833 6.83458 7.665C6.76791 7.60833 6.64458 7.56 6.46458 7.52L5.87458 7.4C5.55125 7.33333 5.30958 7.22 5.14958 7.06C4.98958 6.9 4.90958 6.68667 4.90958 6.42C4.90958 6.19333 4.96958 5.99667 5.08958 5.83C5.20958 5.66333 5.37791 5.53333 5.59458 5.44C5.81458 5.34667 6.07125 5.3 6.36458 5.3C6.61458 5.3 6.84791 5.335 7.06458 5.405C7.28125 5.475 7.45958 5.575 7.59958 5.705L7.36958 6.275C7.23291 6.165 7.07958 6.08333 6.90958 6.03C6.74291 5.97333 6.55625 5.945 6.34958 5.945C6.13291 5.945 5.96625 5.98333 5.84958 6.06C5.73625 6.13667 5.67958 6.24167 5.67958 6.375C5.67958 6.475 5.71458 6.55667 5.78458 6.62C5.85458 6.68 5.97791 6.72833 6.15458 6.765L6.73458 6.88C7.06458 6.94667 7.30958 7.05833 7.46958 7.215C7.62958 7.37167 7.70958 7.58 7.70958 7.84C7.70958 8.06 7.64958 8.25167 7.52958 8.415C7.41291 8.57833 7.24625 8.70667 7.02958 8.8C6.81625 8.89 6.56291 8.935 6.26958 8.935Z",
    fill: "#FAFAFA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 1,
    width: 11.52,
    height: 11.52,
    rx: 5.76,
    fill: "#3394F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7752 7.88L15.5252 4.355H16.3302L17.2252 7.075H17.0102L17.9852 4.355H18.5552L19.4502 7.075H19.2502L20.2002 4.355H20.9552L19.6952 7.88H19.0602L18.1952 5.375H18.3102L17.4152 7.88H16.7752Z",
    fill: "#FAFAFA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 12,
    width: 11.52,
    height: 11.52,
    rx: 5.76,
    fill: "#FFB400"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.02778 18.115C5.02778 17.7484 5.09612 17.43 5.23278 17.16C5.37278 16.8867 5.57278 16.675 5.83278 16.525C6.09278 16.375 6.40112 16.3 6.75778 16.3C7.11445 16.3 7.42278 16.375 7.68278 16.525C7.94278 16.675 8.14278 16.8867 8.28278 17.16C8.42612 17.43 8.49778 17.7467 8.49778 18.11C8.49778 18.48 8.42612 18.8017 8.28278 19.075C8.14278 19.345 7.94278 19.5567 7.68278 19.71C7.42278 19.86 7.11445 19.935 6.75778 19.935C6.40112 19.935 6.09278 19.86 5.83278 19.71C5.57612 19.5567 5.37778 19.3434 5.23778 19.07C5.09778 18.7967 5.02778 18.4784 5.02778 18.115ZM5.84278 18.115C5.84278 18.4784 5.91778 18.7634 6.06778 18.97C6.22112 19.1734 6.45112 19.275 6.75778 19.275C7.05778 19.275 7.28612 19.1734 7.44278 18.97C7.59945 18.7634 7.67778 18.4784 7.67778 18.115C7.67778 17.7484 7.59945 17.465 7.44278 17.265C7.28945 17.0617 7.06112 16.96 6.75778 16.96C6.45112 16.96 6.22112 17.0617 6.06778 17.265C5.91778 17.465 5.84278 17.7484 5.84278 18.115Z",
    fill: "#FAFAFA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 11.5199,
    height: 11.52,
    rx: 5.75996,
    fill: "#E9405B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3653 19.88V16.99H16.2453V16.355H19.2653V16.99H18.1453V19.88H17.3653Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwotColoured);
export default __webpack_public_path__ + "static/media/SWOTColoured.87d1a65b697fcc782b6549e16ee73dd9.svg";
export { ForwardRef as ReactComponent };